import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { PublicBonuses, DepositBonusesRaw, FreeRoundsBonusRaw, GroupedBonusesRaw, PublicLevel, RawLevel } from '@/types';
import { levelAdapter } from '@/adapters/adapters';
import { defaultCurrency } from '@/utils/variables';
export const usePublicEngagementsStore = defineStore('publicEngagements', () => {
    const publicBonuses = ref<PublicBonuses>({
        bonuses: {
            deposit: [],
            free_rounds: []
        },
        bonus_percent: 0,
        free_rounds_count: 0,
        total: 0
    });
    function publicBonusesCount(bonuses: GroupedBonusesRaw<DepositBonusesRaw, FreeRoundsBonusRaw>) {
        const depositCount = bonuses.deposit.length || 0;
        const freeRoundsCount = bonuses.free_rounds.length || 0;
        return depositCount + freeRoundsCount;
    }
    function publicDepositBonusPercent(depositBonuses: DepositBonusesRaw[]) {
        const depositBonusPercent = depositBonuses[0].bonus_percent || 0;
        return depositBonusPercent;
    }
    function publicFreeRoundsCount(freeRoundsBonuses: FreeRoundsBonusRaw[]) {
        const freeRoundsCount = freeRoundsBonuses.reduce((acc, item) => acc + item.count, 0);
        return freeRoundsCount;
    }
    const publicLevels = ref<PublicLevel[]>([]);
    const awaitGetPublicBonuses = async () => {
        try {
            const { data, status } = await axios.get<GroupedBonusesRaw<DepositBonusesRaw, FreeRoundsBonusRaw>>(`/main-api/bonuses/welcome?currency=${defaultCurrency}`);

            if (status === 200) {
                publicBonuses.value = {
                    bonuses: data,
                    bonus_percent: publicDepositBonusPercent(data.deposit),
                    free_rounds_count: publicFreeRoundsCount(data.free_rounds),
                    total: publicBonusesCount(data)
                };
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const awaitGetPublicLevels = async () => {
        try {
            const { data, status } = await axios.get<RawLevel[]>('/main-api/levels');
            if (status === 200) {
                publicLevels.value = data.map((item) => levelAdapter.mapPublicLevel(item));
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    return {
        publicBonuses,
        publicBonusesCount,
        publicDepositBonusPercent,
        publicFreeRoundsCount,
        awaitGetPublicBonuses,
        publicLevels,
        awaitGetPublicLevels
    };
});
